import { render, staticRenderFns } from "./PnrLinkField.vue?vue&type=template&id=114260dc&"
import script from "./PnrLinkField.vue?vue&type=script&lang=ts&"
export * from "./PnrLinkField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports